import { openProcessId } from "@Constants/PortalConstants";

/* This hook was created with Purpose to centraliza a custom logic
 * and with focust o simplify debug and probably a removal of this logic
 * mainly introduced with need to re-render/force user to see the RegisterNow or RulesModal
 * after login/register, but if user closes the modal there is no need to do custom logic
 * found on useEffect of GoToShopButton
 */
export function useProcessId() {
    const set = (itemId?: string) => {
        if (!itemId) return;

        sessionStorage.setItem(openProcessId, itemId);
    };

    const remove = () => {
        sessionStorage.removeItem(openProcessId);
    };

    const get = () => {
        return sessionStorage.getItem(openProcessId);
    };

    return { set, get, remove };
}
